
import {Agent} from 'https';
import {getCookie} from "cookies-next";
import {_getCallerFile} from "../../app/utilities/debug";

const serialize = (toSerialize, prefix) => {
    const keyValuePairs = [];

    Object.keys(toSerialize).forEach((attribute) => {
        if (Object.prototype.hasOwnProperty.call(toSerialize, attribute)) {
            const key = prefix ? `${prefix}[${attribute}]` : attribute;
            const value = toSerialize[attribute];
            const toBePushed =
                value !== null && typeof value === "object"
                    ? serialize(value, key)
                    : `${key}=${value}`;
            keyValuePairs.push(toBePushed);
        }
    });

    return keyValuePairs.join("&");
};

export default function apiFetcher(endpoint, options, extra) {


    //const {locale} = useRouter();

    //console.log(locale);

    const nfSession = getCookie('nf_session');

    const config = {
        //apiToken: 'bofoh1xbkbaatnukpoogryixkbqo7hyu',
        proxyUrl: process.env.NEXT_PUBLIC_PROXY_URL + '/Mg2ApiProxy.php?url='
    };

    let queryString = ( options?.method === 'GET' && options?.data) ? '?' + serialize(options.data) : '';
    //let queryString = '';

    let finalUrl = config.proxyUrl + encodeURIComponent(endpoint + queryString);


    let fetchOptions = {
        method: options?.method ? options.method : 'GET',
        body: options?.data && ( options?.method === 'POST' || options?.method === 'PUT') ? JSON.stringify(options.data) : null,
        headers: {
            ...options?.headers,
            'Accept-Encoding': 'gzip, deflate, br, zstd'
            //'Content-Type': 'application/json',
            //'Content-Type': 'application/json',
            //'Authorization': 'Bearer ' + config.apiToken
        },
        //credentials: 'include',
        agent: new Agent({
            rejectUnauthorized: false,
        })
        //cache: 'no-store'
        //mode: 'no-cors',
    };

    if(options?.next){
        fetchOptions = {
            ...fetchOptions,
            next: options.next
        }
    }

    if(options?.cache){
        fetchOptions = {
            ...fetchOptions,
            cache: options.cache
        }
    }

    if(extra && extra.signal){
        fetchOptions = {
            ...fetchOptions,
            signal: extra.signal
        }
    }

    if(nfSession){
        fetchOptions.headers = {
            ...fetchOptions.headers,
            'x-nf-session': nfSession
        }
    }


  /*  if(process.env.NODE_ENV === 'development') {
        let callerFile = _getCallerFile();
        console.log(`[${callerFile}] [${options?.method}] ${endpoint} ${options?.data ? JSON.stringify(options.data) : ''} - ${finalUrl}`);
    }*/


    return fetch(finalUrl, fetchOptions).then(async res => {
        if (!res) {
            console.error('Response NULL');
            return null;
        }
        if (res.status === 204) {
            console.error('Response 204');
            return null;
        }

        let json = null;

        try {
            json = await res.json();
        } catch (e) {
            if(process.env.NODE_ENV === 'development') {
                console.log(`ERROR: [${options?.method}] ${endpoint} ${options?.data ? JSON.stringify(options.data) : ''} - ${finalUrl}`, e);
            }
            return Promise.reject( res);
        }


        if(json && (json?.status!== true && json?.message)){
            if(process.env.NODE_ENV === 'development') {
                console.log(options.method + ' -> ' + finalUrl + ' -> ' + (options ? JSON.stringify(options) : null) + ' -> ' + (json ? JSON.stringify(json) : null));


                console.log('Request Error: ' + finalUrl);
                /*let error  = new Error('Request Error: ' + finalUrl);
                error.content = json;
                error.content.message_with_parameters = error.content.message;

                try {
                    error.content.message_with_parameters = json.message.replace( /(\%[0-9]+)/g , (match,contents) => {
                        let value = '';
                        if( json.parameters[parseInt(contents.substr(1))-1] )
                            value = json.parameters[parseInt(contents.substr(1))-1];
                        return value;
                    })
                } catch ( e ){}*/

                console.error('Request Error: ' + finalUrl);
            }
            return Promise.reject( json);
        }

        //json._status = res.status;


        return json;


    });

}